function Input({ label, placeholder, type = 'text', value, onChange, className = '', variant = 'default', inputClassName = '', readOnly = false, numericOnly = false, formatNumber = false, formatDecimal = false, decimalPlaces = 4, prefix = '', ...props }) {
  const getBorderClass = () => {
    if (variant === 'error') {
      return 'border-red-500';
    }
    if (variant === 'blue') {
      return 'border-primary-blue border-1';
    }
    return 'border-border-gray focus:ring-primary-blue ';
  };

  const getBackgroundClass = () => {
    if (readOnly) {
      return 'bg-gray-50';
    }
    return 'bg-white';
  };

  const handleChange = (e) => {
    let processedValue = e.target.value;

    if (formatDecimal) {
      const cleanedValue = processedValue.replace(/[^\d.,]/g, '');
      e.target.value = cleanedValue;
    } else if (formatNumber) {
      const numericValue = processedValue.replace(/[^\d]/g, '');
      const formattedValue = numericValue ? parseInt(numericValue).toLocaleString('en-US') : '';
      e.target.value = formattedValue;
    } else if (numericOnly) {
      const numericValue = processedValue.replace(/[^0-9]/g, '');
      e.target.value = numericValue;
    }

    onChange(e);
  };

  // placeholder를 DOM 텍스트로 렌더하여 Weglot이 번역할 수 있게 함 (HTML placeholder 속성은 미사용)
  // date/time류는 비어있을 때 브라우저가 자체적으로 빈 상태를 표시해주므로, 커스텀 오버레이를
  // 같이 그리면 두 텍스트가 겹쳐 보인다 — 그래서 이 타입들은 오버레이를 생략한다.
  const isEmpty = value === null || value === undefined || value === '';
  const isNativePlaceholderType = ['date', 'time', 'datetime-local', 'month', 'week'].includes(type);
  const showPlaceholderOverlay = isEmpty && !!placeholder && !isNativePlaceholderType;

  return (
    <div className={className || "w-full"}>
      {label && (
        <label className="block text-xs font-medium text-text-dark mb-2">
          {label}
        </label>
      )}
      {prefix ? (
        <div className={`relative flex items-center border rounded-lg ${getBorderClass()} ${getBackgroundClass()}`}>
          <span className="pl-2 py-2 text-xs text-gray-500 whitespace-nowrap">
            {prefix}
          </span>
          <input
            type={type}
            value={value}
            onChange={handleChange}
            readOnly={readOnly}
            className={`flex-1 py-2 pr-2 text-xs focus:outline-none bg-transparent ${inputClassName}`}
            {...props}
          />
          {showPlaceholderOverlay && (
            <span className="absolute top-1/2 -translate-y-1/2 text-xs text-gray-400 pointer-events-none truncate right-2"
                  style={{ left: `calc(0.5rem + ${String(prefix).length}ch + 0.5rem)` }}>
              {placeholder}
            </span>
          )}
        </div>
      ) : (
        <div className="relative">
          <input
            type={type}
            value={value}
            onChange={handleChange}
            readOnly={readOnly}
            className={`w-full px-2 py-2 text-xs border rounded-lg focus:outline-none ${getBorderClass()} ${getBackgroundClass()} ${inputClassName}`}
            {...props}
          />
          {showPlaceholderOverlay && (
            <span className="absolute left-2 right-2 top-1/2 -translate-y-1/2 text-xs text-gray-400 pointer-events-none truncate">
              {placeholder}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default Input;
